import { useSelector } from 'react-redux';
import { useLocation, useRouteLoaderData } from 'react-router';
import { SubscriptionCategory } from '../../../../../common/enums.js';
import { deepEqual } from '../../../../../common/utils/objectUtils.js';
import {
  getSubCategoryFromPath,
  pendingSubscriptionActionExistsInState,
} from '../../../../../common/utils/subscriptionUtils.js';
import { MobileSubscriptionBasicDetails } from '../../../../../components/SubscriptionDetails/MobileSubscriptionBasicDetails.js';
import { getMobileSubscriptionLayout } from '../../../../../components/SubscriptionLayout/subscriptionLayoutUtils.js';
import type { MobileSubscriptionLoaderResponse } from '../../../../../common/loaders.js';
import type { State } from '../../../../../selfservice/common/store.js';

export const MobileSubBasicDetailsPath = () => {
  const { pathname } = useLocation();
  const category = getSubCategoryFromPath(pathname);
  const {
    subscription,
    hasPendingActions,
    companyInfo,
    contacts,
    addOnRules,
    addOnRulesMobilePbx,
    subscriptionScheduledChanges,
  } = useRouteLoaderData(
    category === SubscriptionCategory.VOICE ? 'voiceSub' : 'broadbandSub'
  ) as MobileSubscriptionLoaderResponse;
  const subscriptionActionsState = useSelector((s: State) => s?.selfservice?.pendingSubscriptionActions, deepEqual);

  const MobileSubLayout = getMobileSubscriptionLayout(category);
  return (
    <MobileSubLayout
      addOnRules={addOnRules}
      addOnRulesMobilePbx={addOnRulesMobilePbx}
      contacts={contacts}
      companyInfo={companyInfo}
      subscription={subscription}
    >
      <MobileSubscriptionBasicDetails
        subscription={subscription}
        hasPendingActions={
          hasPendingActions ||
          pendingSubscriptionActionExistsInState(subscription.subscriptionId, subscriptionActionsState)
        }
        companyInfo={companyInfo}
        addOnRules={addOnRules}
        addOnRulesMobilePbx={addOnRulesMobilePbx}
        hasScheduledChange={(subscriptionScheduledChanges?.subscriptionScheduledChangeResponses?.length ?? 0) > 0}
      />
    </MobileSubLayout>
  );
};
